import locationHelperBuilder from "redux-auth-wrapper/history4/locationHelper";
import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import { isEmpty } from "lodash";

const locationHelper = locationHelperBuilder({});

const userIsAuthenticatedDefaults = {
  authenticatedSelector: function (state) {
    return !isEmpty(state.user.profile);
  },
  authenticatingSelector: state => state.user.isFetching,
  wrapperDisplayName: "UserIsAuthenticated"
};

export const userIsAuthenticated = (Component) => {
  return connectedRouterRedirect({
    ...userIsAuthenticatedDefaults,
    redirectPath: "/login",
  })(Component);
};

const userIsNotAuthenticatedDefaults = {
  authenticatedSelector: function (state) {
    return (isEmpty(state.user) || isEmpty(state.user.profile));
  },
  wrapperDisplayName: "UserIsNotAuthenticated"
};

export const userIsNotAuthenticated = (Component) => {
  return connectedRouterRedirect({
    ...userIsNotAuthenticatedDefaults,
    redirectPath: (state, ownProps) =>
      NeedsMultiFactorSetup(state, ownProps)
        ? "/two-factor-setup"
        : NeedsMultiFactor(state, ownProps)
          ? "/two-factor-auth"
          : NeedsPasswordChange(state, ownProps)
            ? "/change-password-required"
            : NeedsRedirection(state, ownProps)
              ? "/redirect"
              : locationHelper.getRedirectQueryParam(ownProps) || "/",
    allowRedirectBack: false
  })(Component);
};

const NeedsMultiFactor = (state, ownProps) => {
  return state.user.profile.loginResult && state.user.profile.loginResult.multiFactorRequired && !IsGoingToLogoutRoute(ownProps);
};

const NeedsMultiFactorSetup = (state, ownProps) => {
  return state.user.profile.multiFactorSetupRequired && !IsGoingToLogoutRoute(ownProps);
};

const NeedsRedirection = (state, ownProps) => {
  return (state.user && state.user.redirect && state.user.redirect.returnUrl) && !IsGoingToLogoutRoute(ownProps);
};

const IsGoingToLogoutRoute = (ownProps) => {
  return (locationHelper.getRedirectQueryParam(ownProps) === "/logout");
};

const NeedsPasswordChange = (state, ownProps) => {
  return JSON.parse(sessionStorage.getItem("MustChangePassword")) && !IsGoingToLogoutRoute(ownProps);
};